import { Layout } from 'antd';
import NavBar from "../../components/NavBar";
import RobotItemDetail from "../../components/robot/RobotItemDetail";
const { Content } = Layout;

function RobotItem({ match }) {
   return (
      <Layout className="container main-layout">
         <NavBar />
         <Layout className="bg-gray">  
            <Content className="layout-content">
               <RobotItemDetail/>
            </Content>
         </Layout>
      </Layout>
   );
}

export default RobotItem;
